import { t as translate } from 'i18next';
import getErrorMessage from './getErrorMessage';

// The API returns validation failures as:
//   { errors: [ { code, message, field }, ... ] }
// Known codes are mapped to localized copy in getErrorMessage. For any code we
// don't explicitly map, surface the API's own message(s) instead of a generic
// "something went wrong", so the user sees what actually failed. Multiple
// validation errors are combined into one message.
const handleRequestError = (error, reject) => {
    const errors = Array.isArray(error?.errors) ? error.errors : [];
    const code = errors[0]?.code ?? null;

    if (code === 401) {
        localStorage.removeItem('accessToken');
        window.location.reload();
    }

    // Code 209 (blocked worker) carries the block reason as its message.
    if (code === 209) {
        return reject(errors[0]?.message || getErrorMessage(code));
    }

    const mapped = getErrorMessage(code);
    const generic = translate('somethingWentWrongWhileFetchingTheRequest');

    if (mapped === generic && errors.length) {
        const detailed = errors
            .map((e) => e?.message)
            .filter(Boolean)
            .join('\n');

        if (detailed) return reject(detailed);
    }

    return reject(mapped);
};

export default handleRequestError;
